import { Navigate } from 'react-router-dom'

export const PublicRoute = ({ children, isLogged }) => {
  if (isLogged) {
    return <Navigate to="/info" />
  }

  return children
}
